export enum MethodContactType {
    Temporary = 0,
    Permanent = 1,
}
